module.exports = __webpack_public_path__ + "img/program-poster.8717f6de.jpg";